import { z } from "zod";
import { EVENT_REGISTRATION_STATUS } from "../constants/event.constants";
import { eventCategoryIdSchema } from "./eventCategory.schemas";
import { eventOccasionIdSchema } from "./eventOccasion.schemas";
import { eventOccurrenceIdSchema } from "./eventOccurrence.schemas";

export const eventRegistrationIdSchema = z.coerce.number().int().positive();

export const eventRegistrationSchema = z
	.object({
		eventRegistrationId: eventRegistrationIdSchema.optional(),
		tenantId: z.coerce.number().int().positive(),
		eventOccurrenceId: eventOccurrenceIdSchema,
		eventOccasionId: eventOccasionIdSchema,
		eventCategoryId: eventCategoryIdSchema,
		memberId: z.coerce.number().int().positive().nullable(),
		nonMemberProfileJson: z.record(z.string(), z.any()).nullable(),
		primaryParticipantCount: z.coerce.number().int().min(1).default(1),
		companionCount: z.coerce.number().int().min(0).default(0),
		expectedTotal: z.coerce.number().int().min(1).default(1),
		attendedPrimaryCount: z.coerce.number().int().min(0).default(0),
		attendedCompanionCount: z.coerce.number().int().min(0).default(0),
		status: z.enum(EVENT_REGISTRATION_STATUS).default("pending"),
		cancelledAt: z.coerce.date().nullable(),
		cancelledBy: z.coerce.number().int().positive().nullable(),
		cancelReason: z.string().max(1000).nullable(),
		reminderSevenSentAt: z.coerce.date().nullable(),
		reminderOneSentAt: z.coerce.date().nullable(),
		notesJson: z.record(z.string(), z.any()).nullable(),
		surveyResponsesJson: z.record(z.string(), z.any()).nullable(),
		lineUserId: z.string().max(255).nullable().optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
		paymentStatus: z.string().nullable().optional(),
		paymentMethod: z.string().nullable().optional(),
		paymentId: z.string().nullable().optional(),
	})
	.strict();

export const createEventRegistrationSchema = eventRegistrationSchema
	.omit({
		eventRegistrationId: true,
		expectedTotal: true,
		attendedPrimaryCount: true,
		attendedCompanionCount: true,
		cancelledAt: true,
		cancelledBy: true,
		cancelReason: true,
		reminderSevenSentAt: true,
		reminderOneSentAt: true,
		createdAt: true,
		updatedAt: true,
	})
	.extend({
		memberId: z.coerce.number().int().positive().optional().nullable(),
		tenantId: z.coerce.number().int().positive().optional(),
	})
	.strict();

export const updateEventRegistrationSchema =
	createEventRegistrationSchema.partial({
		eventOccurrenceId: true,
		eventOccasionId: true,
		eventCategoryId: true,
		memberId: true,
		nonMemberProfileJson: true,
		primaryParticipantCount: true,
		companionCount: true,
		status: true,
		cancelledAt: true,
		cancelledBy: true,
		cancelReason: true,
		reminderSevenSentAt: true,
		reminderOneSentAt: true,
		notesJson: true,
		surveyResponsesJson: true,
		paymentStatus: true,
		paymentMethod: true,
		paymentId: true,
	});
